import { apiCall } from '../../utils';
import axios from 'axios';
import { formatToAccountFormData } from '../businessInfo/api';

// --- Business signup (existing, untouched) ---

export const signUp = values => {
  const data = formatToAccountFormData(values);

  return apiCall({
    url: '/users/business-sign-up/',
    method: 'post',
    data,
    headers: {
      'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
      Accept: 'application/json',
    },
  });
};

// --- Customer signup (ported from mobile) ---
// NOTE: original mobile version exported these as a default-export object
// ({ validateCustomerInfo, signUp }). Switched to named exports to match
// this module's existing style (business signUp above), and renamed the
// customer signup call to customerSignUp to avoid clashing with the
// business signUp export in the same file.

export const validateFirebaseCredentials = async values => {
  const response = await axios.post('/users/firebase-auth/', values);
  return response.data;
};

export const validateCustomerInfo = customerInfo =>
  apiCall({
    url: '/users/validate-customer-info/',
    method: 'post',
    data: customerInfo,
  });

export const customerSignUp = values =>
  apiCall({
    url: '/users/customer-sign-up/',
    method: 'post',
    data: values,
  });